import { render, staticRenderFns } from "./FooterLoadPlaceholder.vue?vue&type=template&id=378da2d4&scoped=true"
import script from "./FooterLoadPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterLoadPlaceholder.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterLoadPlaceholder.vue?vue&type=style&index=0&id=378da2d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378da2d4",
  null
  
)

export default component.exports